import { createAction } from 'redux-actions';
import { createDeferredAction } from '../../utils/redux';
import { PROVIDER_MODULE } from '../../configs/moduleNames';
import {
  BEGIN, CLEAR, FAILED, SUCCESSFUL,
} from '../../configs/actionNames';

export const LOAD_PROVIDER_LIST = '_LOAD_PROVIDER_LIST';
export const CREATE_PROVIDER = '_CREATE_PROVIDER';
export const LOAD_PROVIDER_BY_ID = '_LOAD_PROVIDER_BY_ID';
export const EDIT_PROVIDER_BY_ID = '_EDIT_PROVIDER_BY_ID';
export const DELETE_PROVIDER = '_DELETE_PROVIDER';

export const loadProviderList = createDeferredAction(PROVIDER_MODULE + LOAD_PROVIDER_LIST);
export const loadProviderListBegin = createDeferredAction(PROVIDER_MODULE + LOAD_PROVIDER_LIST + BEGIN);
export const loadProviderListSuccessful = createAction(PROVIDER_MODULE + LOAD_PROVIDER_LIST + SUCCESSFUL);
export const loadProviderListFailed = createAction(PROVIDER_MODULE + LOAD_PROVIDER_LIST + FAILED);

export const createProvider = createDeferredAction(PROVIDER_MODULE + CREATE_PROVIDER);
export const createProviderSuccessful = createAction(PROVIDER_MODULE + CREATE_PROVIDER + SUCCESSFUL);
export const createProviderFailed = createAction(PROVIDER_MODULE + CREATE_PROVIDER + FAILED);

export const loadProviderById = createDeferredAction(PROVIDER_MODULE + LOAD_PROVIDER_BY_ID);
export const loadProviderByIdSuccessful = createAction(PROVIDER_MODULE + LOAD_PROVIDER_BY_ID + SUCCESSFUL);
export const loadProviderByIdFailed = createAction(PROVIDER_MODULE + LOAD_PROVIDER_BY_ID + FAILED);
export const loadProviderByIdClear = createDeferredAction(PROVIDER_MODULE + LOAD_PROVIDER_BY_ID + CLEAR);

export const editProviderById = createDeferredAction(PROVIDER_MODULE + EDIT_PROVIDER_BY_ID);
export const editProviderByIdSuccessful = createAction(PROVIDER_MODULE + EDIT_PROVIDER_BY_ID + SUCCESSFUL);
export const editProviderByIdFailed = createAction(PROVIDER_MODULE + EDIT_PROVIDER_BY_ID + FAILED);

export const deleteProvider = createDeferredAction(PROVIDER_MODULE + DELETE_PROVIDER);
export const deleteProviderSuccessful = createAction(PROVIDER_MODULE + DELETE_PROVIDER + SUCCESSFUL);
export const deleteProviderFailed = createAction(PROVIDER_MODULE + DELETE_PROVIDER + FAILED);
